import { useNavigate } from 'react-router-dom';
import { Fragment, ReactNode, useEffect, useRef, useState } from 'react';
import NavigationBar from '../common/NavigationBar';
import { useLazyQuery } from '@apollo/client';
import { GET_CURRENT_USER, GET_GROUPS, GET_ORGANIZATION } from '../../graphQL/queries';
import { IsLoggedIn, getAppId, setAppId, generateAppId } from '../../redux/tokenSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setCurrentOrganization, setCurrentUser, setUserGroup } from '../../redux/appStateSlice';
import { Paths } from '../routes/Routes';
import LoadingSpinner from './LoadingSpinner';
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, getToken, Messaging, isSupported } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import { RegisterPushToken } from "../../graphQL/api";
import { DmwaError } from "../../models/DmwaError";
import { Stack } from 'react-bootstrap';
import { isIos, renderBannerInstall, renderIOSBannerInstall } from '../../helpers/renderHelper';
import { isNull, isEmpty } from 'lodash';

const NavBarWrapper = (props) => {

	const [getCurrentUser, { loading, error, data }] = useLazyQuery(GET_CURRENT_USER,
		{
			variables: {
				isLocationGroup: true,
				hasDrivers: true,
				startDate: process.env.REACT_APP_MANAGER_START_DATE ? process.env.REACT_APP_MANAGER_START_DATE : null ,
				endDate: process.env.REACT_APP_MANAGER_END_DATE ? process.env.REACT_APP_MANAGER_END_DATE : null,
				prevStartDate: process.env.REACT_APP_MANAGER_PREV_START_DATE ? process.env.REACT_APP_MANAGER_PREV_START_DATE : null,
				prevEndDate: process.env.REACT_APP_MANAGER_PREV_END_DATE ? process.env.REACT_APP_MANAGER_PREV_END_DATE : null
			}
		});

	const [getGroups, getGroupResponses] = useLazyQuery(GET_GROUPS,
		{
			variables: {
				isLocationGroup: true,
				hasDrivers: true,
				startDate: process.env.REACT_APP_MANAGER_START_DATE ? process.env.REACT_APP_MANAGER_START_DATE : null ,
				endDate: process.env.REACT_APP_MANAGER_END_DATE ? process.env.REACT_APP_MANAGER_END_DATE : null,
				prevStartDate: process.env.REACT_APP_MANAGER_PREV_START_DATE ? process.env.REACT_APP_MANAGER_PREV_START_DATE : null,
				prevEndDate: process.env.REACT_APP_MANAGER_PREV_END_DATE ? process.env.REACT_APP_MANAGER_PREV_END_DATE : null
			}
		});

	const [hasLoadedAll, setHasLoadedAll] = useState(false)

	// Your web app's Firebase configuration
	// For Firebase JS SDK v7.20.0 and later, measurementId is optional
	const firebaseConfig = {
		apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
		authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
		projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
		storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
		messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
		appId: process.env.REACT_APP_FIREBASE_APP_ID,
		measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
	};

	// Initialize Firebase
	const app = initializeApp(firebaseConfig);
	const analytics = getAnalytics(app);

console.log(process.env.PUBLIC_URL);

	var messaging: Messaging | undefined

	try {
		// isSupported().then(supported => {
		// 	if (supported) {
		// 		messaging = getMessaging(app);
		// 	}
		// })
		messaging = getMessaging(app);
	} catch (e) {
		console.log('Messaging error ', e)
	}

	const [getCurrentOrganization, organizationResponses] = useLazyQuery(GET_ORGANIZATION);

	const [notificationToken, setNotificationToken] = useState('');

	//const [showLoading, setShowLoading] = useState(false)
	const showLoading = loading || organizationResponses.loading || getGroupResponses.loading


	const [loadingTitle, setLoadingTitle] = useState('')
	const isLoggedIn = IsLoggedIn();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const currentUser = useAppSelector(state => state.appState.currentUser);

	function registerTokenWithServer() {
		if (notificationToken) {

			var appDeviceId = getAppId();

			console.log("Initial value of app device id is :", appDeviceId);


			if (!appDeviceId) {
				console.log("Generating new app device id: ");

				appDeviceId = generateAppId();
				console.log("Generated app device id is ", appDeviceId);

				dispatch(setAppId(appDeviceId as string))
			}

			console.log("Calling register push with app device id", appDeviceId);

			RegisterPushToken(notificationToken, appDeviceId, response => {
				if (response instanceof DmwaError) {
					if (response.status === 403) {
						response.message = "Could not register token";
					}
					// else {
					// 	dispatch(setHasRegisteredPush(true))
					// }
				}
			})
		}

		setHasLoadedAll(true)
	}

	function requestPermission() {

		console.log('Requesting permission...');
		try {
			Notification.requestPermission().then((permission) => {
				if (permission === 'granted') {
					console.log('Notification permission granted.');
					requestToken();
				}
			});
		} catch (error) {
			console.error("Error caught in the outer try-catch block:", error);
			setHasLoadedAll(true)
		}
	}

	async function requestToken() {
		// Get registration token. Initially this makes a network call, once retrieved
		// subsequent calls to getToken will return from cache.

		if (messaging) {
			const registration = await navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js?${firebaseConfig}`);

			getToken(messaging, { serviceWorkerRegistration: registration, vapidKey: process.env.REACT_APP_FIREBASE_CLOUD_MESSAGING_PUBLIC_KEY }).then((currentToken) => {
				if (currentToken) {
					setNotificationToken(currentToken);
				} else {
					// Show permission request UI
					console.log('No registration token available. Request permission to generate one.');
					// ...
				}
			}).catch((err) => {
				console.log('An error occurred while retrieving token. ', err);
				// ...
			});
		}
	}

	// This variable will save the event for later use.
	const deferredPrompt = useRef<any>();
	window.addEventListener('beforeinstallprompt', (e) => {
		// Prevents the default mini-infobar or install dialog from appearing on mobile
		e.preventDefault();
		// Save the event because you'll need to trigger it later.
		deferredPrompt.current = e;
		console.log("deferredPrompt = ", deferredPrompt)
		// Show your customized install prompt for your PWA
	});

	async function processDefferedPrompt() {
		console.log('here')

		// const { outcome } = await deferredPrompt?.current?.userChoice;
		// console.log('outcome = ', outcome)

		// // deferredPrompt?.current?.userChoice.then(outcome => {
		// // 	console.log('outcome = ', outcome)
		// // })
	}

	useEffect(()=> {
		if (hasLoadedAll) {
			processDefferedPrompt()
		}
	},[hasLoadedAll, deferredPrompt])

	useEffect(() => {
		if (isLoggedIn && currentUser) {
			if (!notificationToken) {
				requestPermission();
			} else {
				registerTokenWithServer();
			}
		}
	}, [notificationToken, isLoggedIn, currentUser])

	useEffect(() => {
		if (organizationResponses.data?.organization) {
			dispatch(setCurrentOrganization(organizationResponses.data?.organization))

			//Fetch groups after we have current user
			if (!data?.currentUser?.isInDriverRole) {
				//setShowLoading(true)	
				setLoadingTitle("groups")
				getGroups();
			}
		}
	}, [organizationResponses.data?.organization])

	useEffect(() => {
		if (getGroupResponses?.data?.groups) {
			dispatch(setUserGroup({ userId: currentUser?.userID ?? -1, groups: getGroupResponses?.data?.groups }));
		}
	}, [getGroupResponses?.data])

	useEffect(() => {
		if (!isLoggedIn) {
			navigate(Paths.LOGIN)
		} else {
			if (!currentUser) {
				setLoadingTitle("user")
				getCurrentUser()
			}
		}
	}, [isLoggedIn])

	useEffect(() => {
		if (data?.currentUser) {
			//setShowLoading(false)
			dispatch(setCurrentUser(data?.currentUser))

			if (isLoggedIn) {
				setLoadingTitle("organization")
				getCurrentOrganization()
			}

		}
	}, [data?.currentUser])

	useEffect(() => {
		if (messaging) {
			onMessage(messaging, (payload) => {
				console.log('Message received. ', payload);

				const title = (payload?.notification as any).title;
				const body = (payload?.notification as any).body;
				const icon = (payload?.notification as any).icon;
				const fcmOptions = (payload as any).fcmOptions;

				// Create and display a notification here
				const notification = new Notification(title ?? "", {
					body,
					icon: icon ?? `${process.env.PUBLIC_URL}/logo192.png`,
				});

				notification.onclick = () => {
					// Handle notification click event
					// You can redirect the user to a specific page or take any other action here
					navigate(Paths.HOME)
				};
			});
		}

	}, [])

	

	return (
		<Fragment>
			<NavigationBar title={props.title} isHome={props.isHome} />
			{showLoading ?
				<LoadingSpinner title={loadingTitle} />
				:
				<Stack style={{marginTop:55}}>
					{ hasLoadedAll && !isIos() && deferredPrompt.current && renderBannerInstall(deferredPrompt)}
					{ renderIOSBannerInstall() }
					{props.children}
				</Stack>
			}
		</Fragment>
	)
}

export default NavBarWrapper;